import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { LivechatState } from "./types";
import { RootState } from "@/store/types";

const livechat: Module<LivechatState, RootState> = {
  // namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default livechat;
